import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { APIService } from './api.service';
import { StorageService } from './storage.service';
import { SnackBarComponent } from '../components/snack-bar/snack-bar.component';

@Injectable({
  providedIn: 'root',
})

export class DataService {

  user = this.storageService.getUserData();
  currentUser = this.user ? JSON.parse(this.user) : null;
  
  emailValidators =
  /^(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

  statusColor = {
    0: {
      background: '#EDEDED',
      color: '#000000',
    },
    1: {
      background: '#FFC9C9',
      color: '#E14848',
    },
    2: {
      background: '#D3F0DB',
      color: '#01A747',
    },
    3: {
      background: '#FFEDBD',
      color: '#C7940C',
    },
    4: {
      background: '#FFC9C9',
      color: '#E14848',
    },
  }

  constructor(private apiService: APIService, private snackBar: MatSnackBar, private storageService: StorageService) { }

  customSnackBar(message: string, type: string) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      data: {
        message: message,
        type: type,
      },
      duration: type === 'success' ? 3000 : 5000,
    });
  }

  dismiss() {
    this.snackBar?.dismiss()
  }

  // info api
  getInfo(params: any) {
    return this.apiService.get('/info', params)
  }

  // get filters
  getCustomerListFilter() {

    try {

      if (this.storageService.getSessionStorageItem('myCustomerFilter'))
        return JSON.parse(this.storageService.getSessionStorageItem('myCustomerFilter')) || null;
      else
        return null;

    } catch {

      return null;
    }




  }
  // get filters
  setCustomerListFilter(data: any) {
    return this.storageService.setSessionStorageItem('myCustomerFilter', JSON.stringify(data));
  }

}
